import { render, staticRenderFns } from "./AuctionQuestionPopup.vue?vue&type=template&id=a843536a"
import script from "./AuctionQuestionPopup.vue?vue&type=script&lang=js"
export * from "./AuctionQuestionPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports